module.exports = __webpack_public_path__ + "media/luxury-2026/beamed-dining-960-e3844f22.jpg";